import { fromJS } from 'immutable';

import {
  LOAD_PROFILE,
  LOAD_INSTAGRAM,
  LOAD_PAGE,
} from './constants';

const initialState = fromJS({
  influencer: null,
  isError: false,
  isLoading: true,
  instagramFeed: null,
});

function profileReducer(state = initialState, payload){
  switch (payload.type) {
  case LOAD_PROFILE:
    return state
        .set('isLoading', false)
        .set('isError', false)
        .set('influencer', payload.influencer);
  case LOAD_INSTAGRAM:
    return state
        .set('instagramFeed', payload.instagramFeed);
  case LOAD_PAGE:
    return state
        .set('instagramFeed', null)
        .set('isLoading', true);
  default:
    return state;
  }
};

export default profileReducer;



// WEBPACK FOOTER //
// ./src/containers/profile/reducer.js